// Selectors
import { getCurrentBoardId } from '../../reducers/currentBoardId/currentBoardIdSelector';

export const getCurrentBoardInitialCanvasOrigin = (state) => {
    const currentBoardId = getCurrentBoardId(state);
    return state.getIn(['app', 'canvas', 'initialState', currentBoardId, 'canvasOrigin']);
};
